<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px" v-if="formVisible">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="130px">
      <Title v-if="[0,1,2,6].includes(popType)">用户基础信息</Title>
      <el-form-item label="客户姓名：" prop="customerAddDTO.name" v-if="[0,1,2,6].includes(popType)" :class="{'width100':[2,6].includes(popType)}">
        <el-input v-model="form.customerAddDTO.name" placeholder="请输入姓名" :disabled="[2,6].includes(popType)" />
      </el-form-item>
      <el-form-item label="手机号：" prop="customerAddDTO.pho" v-if="[0,1].includes(popType)">
        <el-input v-model="form.customerAddDTO.pho" placeholder="请输入手机号" maxlength="11" />
      </el-form-item>
      <el-form-item label="用友编码：" prop="customerAddDTO.code" v-if="!popType">
        <el-input v-model="form.customerAddDTO.code" placeholder="根据用友返回" disabled />
      </el-form-item>
      <el-form-item :label="popType?'身份：':'客户身份：'" prop="customerAddDTO.clevel" v-if="[0,2,6,7].includes(popType)" :class="{'width100':popType}">
        <el-select v-model="form.customerAddDTO.clevel" placeholder="请选择身份" @change="standingChange" :disabled="[7,6].includes(popType)">
          <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请原因：" v-if="[2].includes(popType)" :class="{'width100':popType==2}">
        <el-input v-model="form.lastDonote" placeholder="请输入申请原因" />
      </el-form-item>
      <el-form-item label="折扣组:" v-if="[0,7].includes(popType)" :class="{'width100':popType==7}">
        <el-select v-model="form.customerAddDTO.profitRatioId" placeholder="请选择">
          <el-option :label="item.title + '(' + item.buyRatio + '折)'" :value="item.id" v-for="item in discountList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修改原因：" v-if="popType==7" class="width100">
        <el-input v-model="form.discountApplyReason" type="textarea" :rows="3" placeholder="请输入原因" />
      </el-form-item>
      <el-form-item label="上传凭证：" v-if="popType==7" class="width100">
        <el-upload
          :action="uploadImgUrl"
          list-type="picture-card"
          :file-list="discountVoucher"
          :on-success="handleDiscountVoucherSuccess"
          :on-remove="handleDiscountVoucherRemove"
          :on-exceed="handleDiscountVoucherExceed"
          :limit="9"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <div class="upload-hint">限制9张</div>
      </el-form-item>
      <el-form-item label="门店类型：" prop="customerAddDTO.shopType" v-if="[0,1].includes(popType) && !form.customerAddDTO.mainId" :rules="[{required: !popType || (popType==1 && form.customerAddDTO.clevel!=8),message: '请选择门店类型',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.shopType" placeholder="请选择门店类型">
          <el-option :label="item" :value="item" v-for="(item,index) in options.storeTypeList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日均门诊量：" prop="customerAddDTO.shopOutpatient" v-if="[0,1].includes(popType)&& !form.customerAddDTO.mainId" :rules="[{required: !popType || (popType==1 && form.customerAddDTO.clevel!=8),message: '请选择日均门诊量',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.shopOutpatient" placeholder="请选择日均门诊量">
          <el-option :label="item" :value="item" v-for="(item,index) in options.frequencyList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工数量：" prop="customerAddDTO.shopCount" v-if="[0,1].includes(popType)&& !form.customerAddDTO.mainId" :rules="[{required: !popType || (popType==1 && form.customerAddDTO.clevel!=8),message: '请选择员工数量',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.shopCount" placeholder="请选择员工数量">
          <el-option :label="item" :value="item" v-for="(item,index) in options.staffNum" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="正在开展项目：" prop="customerAddDTO.carryProjects" v-if="[0,1].includes(popType) && !form.customerAddDTO.mainId" :rules="[{required: !popType || (popType==1 && form.customerAddDTO.clevel!=8),message: '请选择正在开展项目',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.carryProjects" multiple placeholder="请选择正在开展项目">
          <el-option :label="item" :value="item" v-for="(item,index) in options.projectList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="当前区域：" prop="customerAddDTO.addr" v-if="popType==5" class="width100">
        <el-cascader v-model="form.customerAddDTO.addr1" :props="cascaderProps" separator='' collapse-tags :options="addressList" clearable disabled></el-cascader>
      </el-form-item>
      <el-form-item :label="popType==5?'修改区域：':'所属区域：'" prop="customerAddDTO.addr" v-if="[0,5].includes(popType)" :class="{'width100':popType==5}" :rules="[{required: [0,5].includes(popType) || (popType==1 && form.customerAddDTO.clevel!=8),message: '请选择省市区',trigger: 'change'}]">
        <el-cascader v-model="form.customerAddDTO.addr" :props="cascaderProps" collapse-tags :options="addressList" clearable placeholder="请选择省市区" @change="regionChange"></el-cascader>
      </el-form-item>
      <!-- <el-form-item label="城市公司" prop="customerAddDTO.addr" v-if="[0,].includes(popType)" :rules="[{required: true ,message: '请选择城市公司',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.intentionLevel" placeholder="请选择客户意向度">
          <el-option v-for="(item,index) in cityCompanyOptions" :key="index" label="高" value="高"></el-option>
          <el-option label="中" value="中"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="详细地址：" prop="addrDetail">
        <el-input v-model="form.customerAddDTO.addrDetail" placeholder="请输入详细地址" />
      </el-form-item> -->
      <el-form-item label="微信号：" prop="wechat" v-if="[0,1].includes(popType)&& !form.customerAddDTO.mainId">
        <el-input v-model="form.customerAddDTO.wechat" placeholder="请输入客户微信号" />
      </el-form-item>
      <el-form-item label="意向度：" prop="intentionLevel" v-if="[0,1].includes(popType)&& !form.customerAddDTO.mainId" :class="{'width100':popType}">
        <el-select v-model="form.customerAddDTO.intentionLevel" placeholder="请选择客户意向度">
          <el-option label="高" value="高"></el-option>
          <el-option label="中" value="中"></el-option>
          <el-option label="低" value="低"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="note" class="width100" v-if="[0,1].includes(popType)&& !form.customerAddDTO.mainId" :class="{'width100':popType}">
        <el-input v-model="form.customerAddDTO.note" placeholder="请输入备注" />
      </el-form-item>

      <el-form-item :label="popType?'业务员：':'所属业务：'" prop="customerAddDTO.parentId" v-if="[0,3,5,13].includes(popType)" :class="{'width100':popType}" :rules="[{required:[3,5,13].includes(popType),message: '请选择业务员',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.parentId" filterable remote :remote-method="searchUsers" :loading="loading" placeholder="根据名字/手机号搜索" @change="businessChange">
          <el-option :label="`${item.name}（${item.levelName}）`" :value="item.id" v-for="item in businessList" :key="item.id"></el-option>
        </el-select>
        <!-- <span class="font12 c-8F8E8E" v-if="!popType">不选择根据区域默认分配</span> -->
      </el-form-item>
      <el-form-item label="业务线：" prop="" class="width100" v-if="!popType">
        <el-input v-model="customerLine" placeholder="根据选择的业务员自动读取" disabled />
      </el-form-item>
      <el-form-item label="业务标签：" prop="customerTagList" class="width100" v-if="!popType">
        <el-cascader v-model="form.customerAddDTO.customerTagList" :options="labelList" :props="labelProps" :show-all-levels="false" placeholder="请选择业务标签">
        </el-cascader>
      </el-form-item>
      <el-form-item label="技术老师：" prop="customerAddDTO.technicianId" v-if="[0,4,5,14].includes(popType)" :class="{'width100':popType}" :rules="[{required:[4,5,14].includes(popType),message: '请选择技术老师',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.technicianId" placeholder="请选择技术老师" filterable @change="technicianChange">
          <el-option :label="`${item.realName}（${item.levelName}）`" :value="item.id" v-for="item in technicianList" :key="item.id"></el-option>
        </el-select>
        <!-- <span class="font12 c-8F8E8E" v-if="!popType">不选择根据区域默认分配</span> -->
      </el-form-item>
      <el-form-item label="技术线：" prop="" class="width100" v-if="!popType">
        <el-input v-model="technicalLine" placeholder="根据技术老师自动读取" disabled />
      </el-form-item>
      <el-form-item label="技术标签：" prop="customerJSTagList" class="width100" v-if="!popType">
        <el-cascader v-model="form.customerAddDTO.customerJSTagList" :options="labelList" :props="labelProps" :show-all-levels="false" placeholder="请选择技术标签">
        </el-cascader>
      </el-form-item>
      <!-- <template v-if="[0,8].includes(popType)">
        <Title>分润比例</Title>
        <el-form-item label="体验班：" prop="customerAddDTO.incomeRatio">
          <el-input v-model="form.customerAddDTO.incomeRatio" placeholder="请输入">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="研修班：" prop="customerAddDTO.incomeRatio2">
          <el-input v-model="form.customerAddDTO.incomeRatio2" placeholder="请输入">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </template> -->
      <!-- <template v-if="!popType || popType==6 || (popType==2 && customerCertificatesAddDTO==null)"> -->
      <template v-if="!popType || popType==6">
        <Title>认证信息</Title>

        <el-form-item label="认证类型：" prop="customerCertificatesAddDTO.certificatesType" class="width100">
          <el-select v-model="form.customerCertificatesAddDTO.certificatesType" placeholder="请选择认证类型" clearable @change='handleTypeChange'>
            <el-option label="暂不认证" :value="0"></el-option>
            <el-option label="企业认证" :value="1"></el-option>
            <el-option label="个人认证" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- {{form.customerCertificatesAddDTO.certificatesType}} -->
        <template v-show="form.customerCertificatesAddDTO.certificatesType==1">
          <el-form-item label="门店类型：" prop="customerCertificatesAddDTO.companyType" class="width100" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请选择门店类型',trigger: 'change'}]" v-show="form.customerCertificatesAddDTO.certificatesType==1">
            <el-select v-model="form.customerCertificatesAddDTO.companyType" placeholder="请选择门店类型">
              <el-option :label="item" :value="item" v-for="(item,index) in companyOption" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业全称：" prop="customerCertificatesAddDTO.companyName" v-show="form.customerCertificatesAddDTO.certificatesType==1" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请输入企业全称',trigger: 'blur'}]">
            <el-input v-model="form.customerCertificatesAddDTO.companyName" placeholder="请输入企业名称" />
          </el-form-item>
          <!-- <el-form-item label="资质证件类型：" prop="customerCertificatesAddDTO.companyZiZhi" v-show="form.customerCertificatesAddDTO.certificatesType==1" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请选择资质证件类型',trigger: 'change'}]"> -->
          <el-form-item label="资质证件类型：" prop="customerCertificatesAddDTO.companyZiZhi" v-show="form.customerCertificatesAddDTO.certificatesType==1">
            <el-select v-model="form.customerCertificatesAddDTO.companyZiZhi" placeholder="请选择资质证件类型/医疗机构职业许可证/营业执照" @change="handleCompany">
              <el-option label="医疗机构职业许可证" :value="2"></el-option>
              <el-option label="营业执照" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资质证件凭证：" prop="customerCertificatesAddDTO.certificatesImg" class="width100" v-show="form.customerCertificatesAddDTO.certificatesType==1" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请上传资质证件凭证',trigger: 'change'}]">
            <div class="flexs">
              <el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false" :on-success="handleAvatarSuccess">
                <img v-if="form.customerCertificatesAddDTO.certificatesImg" :src="form.customerCertificatesAddDTO.certificatesImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <!-- <el-form-item label="统一社会信用代码/登记号：" prop="customerCertificatesAddDTO.code" v-show="form.customerCertificatesAddDTO.certificatesType==1" :rules="[{required:  form.customerCertificatesAddDTO.certificatesType==1,message: '请输入统一社会信用代码/登记号',trigger: ['blur', 'change']}]"> -->
          <el-form-item label="统一社会信用代码/登记号：" prop="customerCertificatesAddDTO.code" v-show="form.customerCertificatesAddDTO.certificatesType==1">
            <el-input v-model="form.customerCertificatesAddDTO.code" placeholder="根据资质证件凭证读取" :disabled="form.customerCertificatesAddDTO.companyZiZhi==1" />
          </el-form-item>
          <!-- <el-form-item label="纳税人识别号：" prop="customerCertificatesAddDTO.taxpayerCode" v-show="form.customerCertificatesAddDTO.certificatesType==1" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请输入纳税人识别号',trigger: ['blur', 'change']}]"> -->
          <!-- <el-form-item label="纳税人识别号：" prop="customerCertificatesAddDTO.taxpayerCode" v-show="form.customerCertificatesAddDTO.certificatesType==1" >
            <el-input v-model="form.customerCertificatesAddDTO.taxpayerCode" placeholder="请输入纳税人识别号" :disabled="form.customerCertificatesAddDTO.companyZiZhi==1" />
          </el-form-item> -->
        </template>
        <template v-show="form.customerCertificatesAddDTO.certificatesType==2">
          <el-form-item label="姓名：" prop="customerCertificatesAddDTO.companyName" class="width100" v-show="form.customerCertificatesAddDTO.certificatesType==2" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==2,message: '请输入姓名',trigger: 'blur'}]">
            <el-input v-model="form.customerCertificatesAddDTO.companyName" placeholder="请输入姓名" />
          </el-form-item>
          <!-- 审核状态显示 -->
          <el-form-item label="审核状态：" v-if="popType == 6 && form.customerCertificatesAddDTO.auditStatus !== undefined" class="width100">
            <el-tag :type="getAuditStatusType(form.customerCertificatesAddDTO.auditStatus)">
              {{ getAuditStatusText(form.customerCertificatesAddDTO.auditStatus) }}
            </el-tag>
          </el-form-item>
          <el-form-item label="身份证号：" prop="customerCertificatesAddDTO.code" class="width100" v-show="form.customerCertificatesAddDTO.certificatesType==2" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==2,message: '身份证号未识别',trigger: ['blur', 'change']}]">
            <el-input v-model="form.customerCertificatesAddDTO.code" placeholder="根据上传身份证图片读取" disabled />
          </el-form-item>
          <el-form-item label="上传身份证：" prop="advertisingUrl" class="width100" v-show="form.customerCertificatesAddDTO.certificatesType==2">
            <!-- :rules="[{required: true,message:'请上传身份证',trigger: 'change'},{validator: checkCard,trigger: 'change'}]"> -->
            <div class="flexs">
              <el-upload class="card-uploader" :action="uploadImgUrl" :show-file-list="false" :on-success="handleCardSuccess">
                <img v-if="cardImageUrl" :src="cardImageUrl" class="avatar">
                <img src="@/assets/card.png" alt="" v-else />
                <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              </el-upload>
              <el-upload class="card-uploader" :action="uploadImgUrl" :show-file-list="false" :on-success="handleCardBackSuccess">
                <img v-if="cardBackImageUrl" :src="cardBackImageUrl" class="avatar">
                <img src="@/assets/card1.png" alt="" v-else />
              </el-upload>
              <!-- <imageUpload v-model="form.advertisingUrl" width="54" height="54" />
              <imageUpload v-model="form.advertisingUrl" width="54" height="54" /> -->
              <!-- <span class="hint">图片限制数量1张<br />建议尺寸710x320像素以上</span> -->
            </div>
          </el-form-item>
        </template>
      </template>
      <template v-if="[0,2].includes(popType) && form.customerAddDTO.clevel && form.customerAddDTO.clevel!=8 && (!clevel || (clevel>form.customerAddDTO.clevel))">
        <Title>报名费用</Title>
        <el-form-item label="是否上传凭证" prop="isUploadVoucher" :rules="[{ required: true, message: '请选择是否上传凭证', trigger: 'change' }]">
          <el-radio-group v-model="form.isUploadVoucher" @change="handleUploadVoucherChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="赠送礼包：" prop="giftCombineId" class="width100 is-required" v-if="[0,1,2].includes(popType) && (form.isUploadVoucher === 0 || form.isUploadVoucher === 1)" :rules="[{ required: (form.isUploadVoucher == 1) || (form.isUploadVoucher == 0 && isGift == 1), message: '请选择商品及规格', trigger: 'change' }]">
          <div class="flexs">
            <el-select v-model="isGift" placeholder="请选择" @change="handleGiftChange" v-if="form.isUploadVoucher == 0" style="width: 100px;">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="2"></el-option>
            </el-select>
            <el-cascader v-model="selectedGift" :options="goodsCascaderList" placeholder="请选择商品及规格" clearable :disabled="form.customerAddDTO.clevel === 8 || (form.isUploadVoucher == 0 && isGift == 2)" @expand-change="handleExpandGiftChange" />
          </div>
        </el-form-item>
        <template v-if="form.isUploadVoucher==1">
          <el-form-item label="报名费用：" prop="customerRegistrationAddDTO.fee" class="width100" :rules="[{ required: true, message: '请输入报名费用', trigger: 'blur' },{ pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/, message: '请输入正确的费用'}]">
            <el-input v-model="form.customerRegistrationAddDTO.fee" placeholder="请输入报名费用" />
          </el-form-item>
          <el-form-item label="付款凭证：" prop="customerRegistrationAddDTO.registrationPayList" class="width100" :rules="[{ required: true, message: '请上传付款凭证', trigger: 'change' }]">
            <div class="flexs">
              <el-upload :action="uploadImgUrl" list-type="picture-card" :file-list="payVoucher" :on-success="handleImgUpload" :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <span class="hint">支持上传多张</span>
              <!-- <span class="font12 c-main ml20 c-pointer">生成付款码</span> -->
            </div>
          </el-form-item>
          <el-form-item label="申请凭证：" prop="customerRegistrationAddDTO.applyVoucher" class="width100">
            <div class="flexs">
              <el-upload :action="uploadImgUrl" list-type="picture-card" :file-list="applyVoucher" :on-success="handleImgUpload1" :on-remove="handleRemove1">
                <i class="el-icon-plus"></i>
              </el-upload>
              <span class="hint">支持上传多张</span>
            </div>
          </el-form-item>
        </template>
      </template>
      <intent-credit-choice v-if="canUseIntent" ref="intentCredit" :customer-id="form.customerAddDTO.id" :target-level-id="form.customerAddDTO.clevel" :gross-amount="form.customerRegistrationAddDTO.fee" :busy="isLoading" />
      <template v-if="popType==2">
        <Title>其他</Title>
        <el-form-item label="申请原因：" class="width100">
          <el-input v-model="registrationRemark" type="textarea" :rows="3" placeholder="请输入申请原因" />
        </el-form-item>
        <el-form-item label="附件：" class="width100">
          <div class="flexs">
            <el-upload :action="uploadImgUrl" list-type="picture-card" :file-list="attachmentFiles" :on-success="handleAttachmentUpload" :on-remove="handleAttachmentRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="hint">支持上传多张</span>
          </div>
        </el-form-item>
      </template>
      <el-form-item label="使用模块：" prop="customerAddDTO.useModel" :class="{'width100':popType==9}" v-if="popType==9 || (popType == 1 && form.customerAddDTO.mainId)" :rules="[{required:true,message: '请选择使用模块',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.useModel" placeholder="请选择使用模块" multiple>
          <el-option label="学习模块" :value="1"></el-option>
          <el-option label="订货模块" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" v-if="popType == 1 && form.customerAddDTO.mainId">
        <el-switch v-model="form.customerAddDTO.state" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading" :disabled="isConfirmDisabled">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import clientListApi from '@/api/client/clientList'
import sysToolsApi from '@/api/sys/tools'
import clientLabelApi from '@/api/client/label'
import technicianInfoApi from '@/api/technical/technicianInfo'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import SearchCityCompanyApi from '@/api/sys/CityCompanyAddrArea'
import sysGoodsApi from '@/api/sys/sysGoods'
import IntentCreditChoice from '@/components/IntentDeposit/CreditChoice'
import { hasIntentPermission, intentPermissions } from '@/utils/intent-deposit'
function initFormBean() {
  const formBean = {
    customerAddDTO: {
      name: null,
      pho: null,
      code: null,
      clevel: null,
      profitRatioId: null,
      shopType: null,
      shopOutpatient: null,
      shopCount: null,
      carryProjects: null,
      addr: [],
      // addrDetail:null,
      wechat: null,
      intentionLevel: null,
      note: null,
      parentId: null,
      customerTagList: null,
      technicianId: null,
      customerJSTagList: null,
      // incomeRatio: null,
      // incomeRatio2: null,
      customerType: 3,
      source: '后台录入',
      datacompareLogType2: ''
    },
    customerCertificatesAddDTO: {
      certificatesType: 0
    },
    customerRegistrationAddDTO: {
      fee: 0,
      registrationPayList: [],
      applyVoucher: null
    },
    lastDonote: null,
    giftCombineId: null,
    discountApplyReason: null
  }
  return formBean
}

export default {
  //popType 0:新增 1:编辑 2:修改身份 3:转给其他业务员 4:更换老师 5修改区域 6 实名认证7：下单折扣 8:分润比例 9:使用模块 13:转给其他业务员 14:更换老师
  props: {
    standingList: Array,
    discountList: Array,
    configList: Array,
    labelList: Array,
    addressList: Array,
    // technicianList: Array,
    // businessList: Array,
    popType: Number
  },
  components: {
    ImageUpload, IntentCreditChoice
  },
  data() {
    return {
      isGift: 1,
      dataCompareLogRemark: '',
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      uploadImgUrl1: process.env.VUE_APP_BASE_API + '/sys/tools/idCardOCR', // 上传的图片服务器地址
      titleList: ['添加客户', '编辑客户', '修改身份', '转给其他业务员', '更换老师', '修改区域', '修改认证信息', '下单折扣', '分润比例', '使用模块'],
      isLoading: false,
      form: initFormBean(),
      technicalLine: '', //技术线
      customerLine: '', //业务线
      formVisible: false,
      arrList: [],
      technicianList: [],
      businessList: [],
      clevel: null,
      formRules: {
        'customerAddDTO.name': [{
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur'
        }],
        'customerAddDTO.pho': [{
          required: true,
          message: '请输入手机号',
        }, {
          pattern: /^[0-9]*$/,
          message: '请输入正确的手机号'
        }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        'customerAddDTO.clevel': [{
          required: true,
          message: '请选择客户身份',
          trigger: 'change'
        }],
        'customerAddDTO.profitRatioId': [{
          required: true,
          message: '请选择折扣组',
          trigger: 'change'
        }],
        'customerCertificatesAddDTO.certificatesType': [{
          required: true,
          message: '请选择认证类型',
          trigger: 'change'
        }],
        // 'customerAddDTO.shopType': [],
        // 'customerAddDTO.shopOutpatient': [],
        // 'customerAddDTO.shopCount': [],
        // 'customerAddDTO.carryProjects': [],
        // 'customerAddDTO.addr': [],
        // 'customerAddDTO.incomeRatio': [{
        //   required: true,
        //   message: '请输入研修班分润比例',
        //   trigger: 'blur'
        // }],
        // 'customerAddDTO.incomeRatio2': [{
        //   required: true,
        //   message: '请输入体验班分润比例',
        //   trigger: 'blur'
        // }],
      },
      options: {
        projectList: [], //   正在开展项目
        storeTypeList: [], //门店类型
        frequencyList: [], //日均门诊人次
        staffNum: [] //员工数量
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        // multiple: true
      },
      labelProps: {
        label: 'name',
        value: 'id',
        children: 'children',
        multiple: true
      },
      payVoucher: [],
      applyVoucher: [],
      attachmentFiles: [],
      registrationRemark: '',
      cardImageUrl: '',
      cardBackImageUrl: '',
      companyOption: [],
      selectItems: [],
      rowItem: null,
      customerCertificatesId: null,
      goodsList: [],
      goodsCascaderList: [], // 商品及规格的级联数据
      selectedGift: [],
      discountVoucher: []
    }
  },
  computed: {
    canUseIntent() { return this.popType === 2 && hasIntentPermission(this.$store, intentPermissions.joinReview) && ((Number(this.clevel) === 8 && [6, 7].includes(Number(this.form.customerAddDTO.clevel))) || (Number(this.clevel) === 7 && Number(this.form.customerAddDTO.clevel) === 6)) },
    // 确认按钮是否禁用
    isConfirmDisabled() {
      // 如果是实名认证弹窗且审核状态为待审核(0)，则禁用确认按钮
      return this.popType === 6 && 
             this.form.customerCertificatesAddDTO && 
             this.form.customerCertificatesAddDTO.auditStatus === 0
    }
  },
  created() {
    this.getGoodsList()
  },
  watch: {
    selectedGift: {
      handler(newVal) {
        if (newVal && newVal.length === 2) {
          // 当级联选择器选择商品和规格时，更新 giftCombineId
          this.$set(this.form, 'giftCombineId', newVal[1])
        } else {
          this.$set(this.form, 'giftCombineId', '')
        }
      },
      immediate: true
    }
  },
  methods: {
    // 将门店类型中文名称转换为数字
    getCompanyTypeNumber(companyTypeName) {
      const companyTypeMap = {
        '诊所': 0,
        '私立医院': 1,
        '卫生室': 2,
        '单体店': 3,
        '社区卫生服务站': 4,
        '美容院': 5
      }
      // 如果传入的是数字，直接返回；如果是中文名称，返回对应数字；否则返回原值
      if (typeof companyTypeName === 'number') {
        return companyTypeName
      }
      return companyTypeMap[companyTypeName] !== undefined ? companyTypeMap[companyTypeName] : companyTypeName
    },
    // 将门店类型数字转换为中文名称
    getCompanyTypeName(companyType) {
      const companyTypeMap = {
        0: '诊所',
        1: '私立医院',
        2: '卫生室',
        3: '单体店',
        4: '社区卫生服务站',
        5: '美容院'
      }
      // 如果传入的是字符串（非数字），直接返回；如果是数字，返回对应中文名称；否则返回原值
      if (typeof companyType === 'string' && isNaN(companyType)) {
        return companyType
      }
      const num = Number(companyType)
      return companyTypeMap[num] !== undefined ? companyTypeMap[num] : companyType
    },
    // 获取审核状态文本
    getAuditStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '同意',
        '-1': '驳回'
      }
      return statusMap[status] || '未知'
    },
    // 获取审核状态标签类型
    getAuditStatusType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        '-1': 'danger'
      }
      return typeMap[status] || 'info'
    },
    handleUploadVoucherChange(value) {
      if (value === 0 && this.isGift === 2) {
        this.selectedGift = []
        this.$set(this.form, 'giftCombineId', '')
      }
    },
    handleGiftChange(value) {
      if (value === 2) {
        // 选择"否"时清空 selectedGift
        this.selectedGift = []
        this.$set(this.form, 'giftCombineId', '')
      }
    },
    async getGoodsList() {
      const { data } = await sysGoodsApi.getGoodRecomList({ isListing: 1 })
      this.goodsList = data
      // 生成级联数据
      this.goodsCascaderList = data.map(goods => ({
        value: goods.id,
        label: goods.name,
        goodsCode: goods.goodsCode,
        children: (goods.specValueList || []).map(spec => ({
          value: spec.id,
          label: spec.spec || '无规格值'
        }))
      }))
    },
    handleExpandGiftChange(val) {
      if (val && val.length === 1) {
        const parent = this.goodsCascaderList.find(item => item.value === val[0])
        if (parent && parent.children && parent.children.length === 1) {
          this.selectedGift = [val[0], parent.children[0].value]
        }
      }
    },
    // 生成商品及规格的级联数据
    generateGoodsCascaderList(goodsList) {
      const goodsCascaderList = goodsList.map(goods => {
        const goodsItem = {
          label: goods.name,
          value: goods.id,
          children: []
        }
        if (goods.specValueList && goods.specValueList.length > 0) {
          goodsItem.children = goods.specValueList.map(spec => ({
            label: spec.name,
            value: spec.id
          }))
        }
        return goodsItem
      })
      this.goodsCascaderList = goodsCascaderList
    },
    // 获取技术老师列表
    async getTechnicianList(e) {
      let params = { status: 10 }
      if (e) {
        params.isGetAllParent = true
        // params.areaDistrictCode = e[e.length - 1]
        // params.areaProvinceCode = e[0]
        // params.areaCityCode = e[1]
        // params.levelIdSortSign = 1
      }
      const { data } = await technicianInfoApi.listForMini(params)
      if (data.length) {
        this.technicianList = data
        // 优先选技术老师(level=3)，不选技术总监(level=1/7)
        const defaultTech = data.find(i => i.levelId === 3) || data[data.length - 1]
        this.technicianChange(defaultTech.id)
      }
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getBusinessList(query)
        }, 500);
      } else {
        this.businessList = [];
      }
    },
    // 获取业务员列表
    async getBusinessList(e) {
      const {
        data
      } = await clientListApi.getListPageForMini({
        isGetAllParent: true,
        // areaDistrictCode: e[e.length - 1],
        // areaProvinceCode: e[0],
        // areaCityCode: e[1],
        levelIdSortSign: 1,
        customerTypes: 2,
        isDeparted: 0,
        nameOrPho: e,
        pageSize: 100
      })
     
      // clientListApi.getListPageForMini({districtCode:e[e.length-1],customerTypes:2}).then((({data})=>{
      if (data.list.length) {
        this.businessList = data.list
        this.businessChange(data.list[data.list.length - 1].id)
      }
    },
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'shopType'
      }).then(({
        data
      }) => {
        this.companyOption = data.list[0].content.split(',')
        // this.configList=data.list
        // console.log("配置: ",data);
      })
    },
    handleTypeChange(e) {
      // console.log('e: ', e);
      // if (this.popType == 6) {
      // console.log('this.form.customerCertificatesAddDTO.id',this.form.customerCertificatesAddDTO.id)
      // let id=this.form.customerCertificatesAddDTO.id?this.form.customerCertificatesAddDTO.id:null
      this.form.customerCertificatesAddDTO = {}
      if (this.customerCertificatesId) {
        this.form.customerCertificatesAddDTO.id = this.customerCertificatesId
      }
      this.form.customerCertificatesAddDTO.certificatesType = e
      this.form.customerCertificatesAddDTO.submitApplyType = 3
      this.cardImageUrl = ''
      this.cardBackImageUrl = ''
      // }
      if (e == 2) {
        // this.formRules['advertisingUrl']=[{ validator: this.checkCard, trigger: 'change' }]
        // console.log('this.formRules:1111 ', this.formRules);
        this.$set(this.formRules, 'advertisingUrl', [{
          validator: (rule, value, callback) => {
            // console.log('============1', this.form.customerCertificatesAddDTO.certificatesType, this.popType);
            if (this.form.customerCertificatesAddDTO.certificatesType == 2 && (!this
              .cardImageUrl || !this.cardBackImageUrl)) {
              callback(new Error('请上传身份证'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }])

      }
    },
    handleCompany(e) {
      // console.log('e: ',e);
      if (!this.form.customerCertificatesAddDTO.code) return
      if (e == 2) {
        this.$set(this.form.customerCertificatesAddDTO, 'taxpayerCode', this.form.customerCertificatesAddDTO.code)
      } else {
        this.$set(this.form.customerCertificatesAddDTO, 'taxpayerCode', '')
      }
    },
    handleCardSuccess(res, file) {
      this.cardImageUrl = res.data
      sysToolsApi.idCardOCR({
        imageUrl: res.data
      }).then((res) => {
        this.$set(this.form.customerCertificatesAddDTO, 'code', res.data.idNum)
        // console.log('res: ',res);
        // this.form.customerCertificatesAddDTO.code=res.data.regNum
        // console.log('this.form.customerCertificatesAddDTO.companyZiZhi: ',this.form.customerCertificatesAddDTO.companyZiZhi);

      })
    },
    handleCardBackSuccess(res, file) {
      this.cardBackImageUrl = res.data
    },
    handleAvatarSuccess(res, file) {
      this.$set(this.form.customerCertificatesAddDTO, 'code', '')
      if (this.form.customerCertificatesAddDTO.companyZiZhi == 1) {
        this.$set(this.form.customerCertificatesAddDTO, 'taxpayerCode', '')
      }
      this.$set(this.form.customerCertificatesAddDTO, 'certificatesImg', res.data)
      if (this.form.customerCertificatesAddDTO.companyZiZhi == 1) {
        this.loading = this.$loading({
          lock: true,
          text: "上传中",
          background: "rgba(0, 0, 0, 0.7)",
        });
        sysToolsApi.bizLicenseOCR({
          imageUrl: res.data
        }).then((res) => {
          this.$set(this.form.customerCertificatesAddDTO, 'code', res.data.regNum)
          if (this.form.customerCertificatesAddDTO.companyZiZhi == 1) {
            this.$set(this.form.customerCertificatesAddDTO, 'taxpayerCode', res.data.regNum)
          }
          this.loading.close();
        }).catch(() => {
          this.loading.close();
        })
      }

    },
    handleImgUpload(response, file, fileList) {
      if (file && file.response) {
        this.payVoucher.push({
          url: file.response.data
        })
        if (this.payVoucher.length) {
          let arr = this.payVoucher.map(i => ({
            payImg: i.url,
            registrationId: 0,
            state: 0
          }))
          this.$set(this.form.customerRegistrationAddDTO, 'registrationPayList', arr)
        }
        // this.form.customerRegistrationAddDTO.registrationPayList = this.payVoucher.length ? this.payVoucher.map(i =>
        //   ({
        //     payImg: i.url,
        //     state: 0
        //   })) : [];
        console.log('this.form.customerRegistrationAddDTO.registrationPayList: ', this.form.customerRegistrationAddDTO.registrationPayList, this.payVoucher);
      }
    },
    handleRemove(file, fileList) {
      // console.log('12',file, fileList);
      this.payVoucher = fileList
      if (this.payVoucher.length) {
        let arr = this.payVoucher.map(i => ({
          payImg: i.url,
          registrationId: 0,
          state: 0
        }))
        this.$set(this.form.customerRegistrationAddDTO, 'registrationPayList', arr)
      }
      // this.form.customerRegistrationAddDTO.registrationPayList = this.payVoucher.length ? this.payVoucher.map(i => ({
      //   payImg: i.url,
      //   state: 0
      // })) : [];
    },
    handleImgUpload1(response, file, fileList) {
      if (file && file.response) {
        this.applyVoucher.push({
          url: file.response.data
        })
      }
    },
    handleRemove1(file, fileList) {
      this.applyVoucher = fileList
    },
    handleAttachmentUpload(response, file, fileList) {
      if (file && file.response) {
        this.attachmentFiles.push({ url: file.response.data })
      }
    },
    handleAttachmentRemove(file, fileList) {
      this.attachmentFiles = fileList
    },
    resetForm() {
      this.form = initFormBean()
      this.applyVoucher = []
      this.attachmentFiles = []
      this.registrationRemark = ''
      this.payVoucher = []
      this.discountVoucher = []
      this.businessList = []
      this.technicianList = []
      this.cardImageUrl = ''
      this.cardBackImageUrl = ''
      this.selectedGift = []
      this.isGift = 1

      // 重置礼包选择
    },
    handleDiscountVoucherSuccess(res, file, fileList) {
      if (res && res.data) {
        this.discountVoucher = fileList.map(f => ({
          url: (f.response && f.response.data) || f.url,
          uid: f.uid
        }))
      } else {
        this.$message.error((res && res.msg) || '上传失败')
      }
    },
    handleDiscountVoucherRemove(file, fileList) {
      this.discountVoucher = fileList.map(f => ({
        url: (f.response && f.response.data) || f.url,
        uid: f.uid
      }))
    },
    handleDiscountVoucherExceed() {
      this.$message.warning('最多只能上传9张图片')
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      // console.log('this.configList1111111111: ',this.configList);
      this.$nextTick(() => {

        this.$refs['dataForm'].clearValidate()
        this.configList.forEach(i => {
          if (i.code == "carryProjects") this.options.projectList = i.content.split(',')
          if (i.code == "shopType") this.options.storeTypeList = i.content.split(',')
          if (i.code == "dayAVGOutpatients") this.options.frequencyList = i.content.split(',')
          if (i.code == "employeeNums") this.options.staffNum = i.content.split(',')
          // console.log('staffNum: ', this.options.staffNum);
        })
      })
    },
    async handleUpdate({ row, command }) {
      console.log('popType: ', this.popType);
      this.resetForm()
      if (command) {
        if (command == 13 || command == 14) {
          this.selectItems = row
          this.getTechnicianList()
        } else {
          let { data } = await clientListApi.fetchById(row.customer.id)
          this.rowItem = data
          this.form.customerAddDTO = JSON.parse(JSON.stringify(data.customer))
          if (command === 7) {
            this.originalProfitRatioId = (data.sysProfitRatio && data.sysProfitRatio.id) || data.customer.profitRatioId
          }
          if (command == 2) {
            this.clevel = data.customer.clevel
          }
          if ([3, 4, 5].includes(command)) {
            // console.log(': ',);
            let arr = data.addr.map(i => (i.regionCode))
            this.technicianList = []
            this.businessList = []
            this.getTechnicianList(arr)
            // this.getBusinessList(arr)
            this.form.customerAddDTO.addr1 = [data.customer.addrProvinceCode, data.customer.addrCityCode, data.customer
              .addrAreaCode
            ]
          }
          if ([0, 3, 5, 13].includes(command)) {
            if (data.line) {
              // ${item.name}（${item.levelName}）`" :value="item.id" 
              this.businessList = [{ name: data.line.name, id: data.line.id, levelName: data.lineLevel && data.lineLevel.name }]
            }
          }
          if ([0, 1].includes(command)) {
            let { carryProjects } = this.form.customerAddDTO
            this.form.customerAddDTO.carryProjects = carryProjects ? carryProjects.split(',') : []
          }
          if (data.customerCertificates) {
            this.form.customerCertificatesAddDTO = JSON.parse(JSON.stringify(data.customerCertificates))
            // 如果 companyType 是数字，转换为中文名称以便在表单中显示
            if(!this.form.customerCertificatesAddDTO.companyType){
              this.form.customerCertificatesAddDTO.companyType=this.form.customerCertificatesAddDTO.waitCompanyType;
            }
            if (this.form.customerCertificatesAddDTO.companyType !== null && this.form.customerCertificatesAddDTO.companyType !== undefined) {
              this.form.customerCertificatesAddDTO.companyType = this.getCompanyTypeName(this.form.customerCertificatesAddDTO.companyType)
            }
            if (command == 6) {
              this.customerCertificatesId = this.form.customerCertificatesAddDTO.id
            }
          }
          if (this.form.customerAddDTO.useModel) {
            let arr = this.form.customerAddDTO.useModel.split('#')
            arr = arr.map(i => i * 1).filter(i => i)
            // console.log('arr: ',arr);
            // this.form.customerAddDTO.useModel=
            this.$set(this.form.customerAddDTO, 'useModel', arr)
          }
          let arrs = [data.customer.addrProvinceCode, data.customer.addrCityCode, data.customer
            .addrAreaCode]
          this.$set(this.form.customerAddDTO, 'addr', arrs)
          // this.form.customerAddDTO.addr = [row.customer.addrProvinceCode, row.customer.addrCityCode, row.customer
          //   .addrAreaCode
          // ]
          if (data.customerRegistrationPO && data.customerRegistrationPO.payList && data.customerRegistrationPO.payList.length) {
            this.arrList = data.customerRegistrationPO.payList
          }
          if ([6, 7].includes(this.form.customerAddDTO.clevel)) {
            // 确保 customerRegistrationAddDTO 始终有初始值，避免降级为普通人员时访问属性报错
            this.form.customerRegistrationAddDTO = data.customerRegistrationPO ? { ...initFormBean().customerRegistrationAddDTO, ...data.customerRegistrationPO } : initFormBean().customerRegistrationAddDTO
            if (data.customerRegistrationPO && data.customerRegistrationPO.payList && data.customerRegistrationPO.payList.length) {
              this.payVoucher = row.customerRegistrationPO.payList.map(i => ({
                url: i.payImg,
                uid: i.id
              }))
            }
            if (data.customerRegistrationPO && data.customerRegistrationPO.applyVoucher) {
              let imgArr = data.customerRegistrationPO.applyVoucher.split(',')
              this.applyVoucher = imgArr.map((i, index) => ({
                url: i,
                uid: `${index}_${+new Date()}`
              }))
            }
          }

        }

        console.log('this.form: ', this.form);
      }
      // this.getConfig()
      this.companyOption = this.configList.find(i => i.code == 'shopType').content.split(',')
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.configList.forEach(i => {
          if (i.code == "carryProjects") this.options.projectList = i.content.split(',')
          if (i.code == "shopType") this.options.storeTypeList = i.content.split(',')
          if (i.code == "dayAVGOutpatients") this.options.frequencyList = i.content.split(',')
          if (i.code == "employeeNums") this.options.staffNum = i.content.split(',')
          if (this.form.customerCertificatesAddDTO.certificatesType == 2) {
            let imgArr = this.form.customerCertificatesAddDTO.certificatesImg.split(',')
            this.cardImageUrl = imgArr[0]
            this.cardBackImageUrl = imgArr[1]
          }

          // console.log('staffNum: ', this.options.staffNum);
        })
      })
    },
    doCreate() {
      if (this.isLoading) return
      const intentContext = () => ({ customerId: this.form.customerAddDTO.id, targetLevelId: this.form.customerAddDTO.clevel, grossAmount: this.form.customerRegistrationAddDTO.fee })
      try { if (this.canUseIntent && this.$refs.intentCredit) this.$refs.intentCredit.getSubmission(intentContext()) } catch (error) { this.$message.warning(error.message); return }
      // console.log('-----12----',this.applyVoucher);
      // return
      this.$refs["dataForm"].validate((valid, invalidFields) => {
        console.log(invalidFields)
        if (valid) {
          this.isLoading = true
          // console.log('this.form: ', this.form);
          // return
          if (this.form.customerRegistrationAddDTO && this.form.customerRegistrationAddDTO.fee) {
            this.form.customerRegistrationAddDTO.fee = this.form.customerRegistrationAddDTO.fee * 1
          }
          if (!this.popType) {
            let params = JSON.parse(JSON.stringify({
              ...this.form,
            }))
            delete params.isUploadVoucher
            params.customerAddDTO.carryProjects = params.customerAddDTO.carryProjects ? params.customerAddDTO.carryProjects.toString() : ''
            // let params = {
            //   ...this.form,
            // }
            // if(this.applyVoucher)
            params.customerRegistrationAddDTO.applyVoucher = this.applyVoucher.length ? this.applyVoucher.map(
              i => i.url)
              .join(',') : '';
            if (!this.form.customerCertificatesAddDTO.certificatesType) {
              params.customerCertificatesAddDTO = null
            } else if (this.form.customerCertificatesAddDTO.certificatesType == 2) {
              // 个人认证
              // console.log('1111111');
              params.customerCertificatesAddDTO.certificatesImg =
                `${this.cardImageUrl},${this.cardBackImageUrl}`
              params.customerCertificatesAddDTO.companyZiZhi = 3
              params.customerCertificatesAddDTO.submitApplyType = 3
            } else if (this.form.customerCertificatesAddDTO.certificatesType == 1 && params.customerCertificatesAddDTO && params.customerCertificatesAddDTO.companyType) {
              // 企业认证，将 companyType 转换为数字
              params.customerCertificatesAddDTO.companyType = this.getCompanyTypeNumber(params.customerCertificatesAddDTO.companyType)
            }
            params.customerRegistrationAddDTO.registrationType = 1
            if (!this.form.customerAddDTO.clevel || this.form.customerAddDTO.clevel == 8) params
              .customerRegistrationAddDTO = null
            if (this.form.customerAddDTO.addr.length) {
              params.customerAddDTO.addrProvinceCode = params.customerAddDTO.addr[0]
              params.customerAddDTO.addrCityCode = params.customerAddDTO.addr[1]
              params.customerAddDTO.addrAreaCode = params.customerAddDTO.addr[2]
            }
            delete params.customerAddDTO.addr
            params.customerAddDTO.customerTagList = params.customerAddDTO.customerTagList ? params.customerAddDTO
              .customerTagList.map(i => i[1]) : null
            params.customerAddDTO.customerJSTagList = params.customerAddDTO.customerJSTagList ? params
              .customerAddDTO.customerJSTagList.map(i => i[1]) : null
            params.customerAddDTO.isIntern = 0
            // if ([6, 7].includes(this.form.customerAddDTO.clevel)) {
            //   params.customerAddDTO.state = 2
            // } else {
            params.customerAddDTO.state = 1
            // }
            params.dataCompareLogType2 = 1
            // console.log('params----: ', params);
            // return
            if (!this.form.isUploadVoucher) {
              params.customerRegistrationAddDTO = null
            }
            params.isUseParentWallet = 0
            if (this.popType == 0 && this.form.customerAddDTO.clevel && this.form.customerAddDTO.clevel!=8 && (!this.clevel || (this.clevel>this.form.customerAddDTO.clevel))) params.giftCombineId = this.form.giftCombineId
            clientListApi.create(params).then((data) => {
              this.technicalLine = ''
              this.customerLine = ''
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            })
          }
          if (this.popType === 7) {
            const d = this.form.customerAddDTO
            const imgUrls = (this.discountVoucher || []).map(f => f.url).filter(Boolean)
            const params = {
              customerId: d.id,
              fromLevel: d.clevel,
              fromProfitRatioId: this.originalProfitRatioId || d.profitRatioId || 0,
              toLevel: d.clevel,
              toProfitRatioId: d.profitRatioId,
              reason: this.form.discountApplyReason || '',
              imgUrl: imgUrls.join(',')
            }
            clientListApi.addChangProfitRatio(params).then(() => {
              this.postCallback()
            }).catch(res => {
              this.isLoading = false
            })
          }
          if ([1, 8, 9].includes(this.popType)) {
            let params = {
              ...this.form.customerAddDTO
            }
            console.log(1111, params)
            if (this.popType == 1) {
              params.carryProjects = params.carryProjects ? params.carryProjects.toString() : ''
              params.dataCompareLogType2 = 4
            }
            if (this.form.customerAddDTO.addr && this.form.customerAddDTO.addr.length) {
              params.addrProvinceCode = params.addr[0]
              params.addrCityCode = params.addr[1]
              params.addrAreaCode = params.addr[2]
            }
            delete params.addr
            if (this.popType == 9) {
              params.useModel = params.useModel.join('#')
              params.dataCompareLogType2 = 11
            }
            // console.log('params----: ',params);
            // return
            if (this.popType == 1 && this.form.customerAddDTO.mainId) {
              // console.log('params-----: ',params);
              let params2 = {
                id: params.id,
                dataCompareLogType2: params.dataCompareLogType2,
                name: params.name,
                pho: params.pho,
                state: params.state,
                useModel: params.useModel.join('#')
              }
              clientListApi.subaccountEdit(params2).then((data) => {
                this.postCallback(data)
              }).catch(res => {
                this.isLoading = false
              })
            } else {
              if (this.popType == 1 && this.form.customerAddDTO.clevel && this.form.customerAddDTO.clevel!=8 && (!this.clevel || (this.clevel>this.form.customerAddDTO.clevel))) params.giftCombineId = this.form.giftCombineId
              clientListApi.update(params).then((data) => {
                this.postCallback(data)
              }).catch(res => {
                this.isLoading = false
              })
            }

          }
          if ([2, 6].includes(this.popType)) {
            let params = {
              version: 2//20260312版本号放到最外层
            }
            if (this.popType == 2) {
              // 确保 customerRegistrationAddDTO 有初始值（研修班降级为普通人员时可能为null）
              if (!this.form.customerRegistrationAddDTO) {
                this.form.customerRegistrationAddDTO = initFormBean().customerRegistrationAddDTO
              }
              // 降级为普通人员时不需要赋值凭证，后续会直接置为null
              if (this.form.customerAddDTO.clevel !== 8) {
                this.form.customerRegistrationAddDTO.registrationPayList = this.payVoucher.length ? this.payVoucher
                  .map(i => ({
                    payImg: i.url,
                    state: 0,
                    dataType:0,
                    registrationId: 0,
                  })) : [];
                const voucherUrls = this.applyVoucher.map(i => i.url);
                const attachmentUrls = this.attachmentFiles.map(i => i.url);
                this.form.customerRegistrationAddDTO.applyVoucher = [...voucherUrls, ...attachmentUrls].join(',') || '';
              }
            }
            if (!this.form.customerCertificatesAddDTO.certificatesType) {
              params.customerCertificatesUpdateDTO = null
              params.customerCertificatesAddDTO = null
            } else {
              params.customerCertificatesAddDTO = null
              if (this.form.customerCertificatesAddDTO.id) {
                params.customerCertificatesUpdateDTO = {
                  id: this.form.customerCertificatesAddDTO.id,
                  waitCertificatesType: this.form.customerCertificatesAddDTO.certificatesType,
                  waitCertificatesImg: this.form.customerCertificatesAddDTO.certificatesImg,
                  waitCode: this.form.customerCertificatesAddDTO.code,
                  waitCompanyName: this.form.customerCertificatesAddDTO.companyName,
                  waitCompanyType: this.getCompanyTypeNumber(this.form.customerCertificatesAddDTO.companyType),
                  waitCompanyZiZhi: this.form.customerCertificatesAddDTO.companyZiZhi,
                  waitTaxpayerCode: this.form.customerCertificatesAddDTO.taxpayerCode,
                  submitApplyType: 3
                }
                if (this.form.customerCertificatesAddDTO.certificatesType == 2) {
                  // 个人认证
                  params.customerCertificatesUpdateDTO.waitCertificatesImg =
                    `${this.cardImageUrl},${this.cardBackImageUrl}`
                  params.customerCertificatesUpdateDTO.waitCompanyZiZhi = 3
                }
              } else {
                params.customerCertificatesAddDTO = {
                  id: this.form.customerCertificatesAddDTO.id,
                  certificatesType: this.form.customerCertificatesAddDTO.certificatesType,
                  certificatesImg: this.form.customerCertificatesAddDTO.certificatesImg,
                  code: this.form.customerCertificatesAddDTO.code,
                  companyName: this.form.customerCertificatesAddDTO.companyName,
                  companyType: this.getCompanyTypeNumber(this.form.customerCertificatesAddDTO.companyType),
                  companyZiZhi: this.form.customerCertificatesAddDTO.companyZiZhi,
                  taxpayerCode: this.form.customerCertificatesAddDTO.taxpayerCode,
                  submitApplyType: 3
                }
                if (this.form.customerCertificatesAddDTO.certificatesType == 2) {
                  // 个人认证
                  params.customerCertificatesAddDTO.certificatesImg =
                    `${this.cardImageUrl},${this.cardBackImageUrl}`
                  params.customerCertificatesAddDTO.companyZiZhi = 3
                }
              }
            }
            if (this.popType !== 2) {
              if (this.popType == 6 || (this.form.customerAddDTO.clevel == 8)) {
                params.customerRegistrationAddDTO = null
              } else {
                params.customerRegistrationAddDTO = this.form.customerRegistrationAddDTO
                params.customerRegistrationAddDTO.customerId = this.form.customerAddDTO.id
              }
              params.dataCompareLogType2 = 9
            } else {
              params.dataCompareLogType2 = 5
            }
            let { id, clevel, name, parentId } = this.form.customerAddDTO
            params.id = id
            params.clevel = clevel
            params.name = name
            params.parentId = parentId || 0
            // 身份相同不做处理
            if (this.clevel === params.clevel && this.popType !== 6) {
              this.formVisible = false
              this.isLoading = false
              return
            }
            if (this.clevel) params.customerCertificatesUpdateDTO = null
            if (this.popType == 2) {
              // 判断是否降级：数字越小等级越高，clevel数字变大为降级
              const isDowngrade = this.clevel < params.clevel
              let dataSource = 2 // 固定值
              let registrationType = 3 // 默认值
              if (isDowngrade) {
                params.dataCompareLogType2 = 20
                // 降级时根据原身份和目标身份设置registrationType
                if (this.clevel === 7 && params.clevel === 8) {
                  registrationType = 10 // 体验班降级为普通人员
                } else if (this.clevel === 6 && params.clevel === 8) {
                  registrationType = 20 // 研修班降级为普通人员
                } else if (this.clevel === 6 && params.clevel === 7) {
                  registrationType = 30 // 研修班降级体验班
                }
              } else {
                // 升级时根据原身份和目标身份设置registrationType
                if (this.clevel === 8 && params.clevel === 6) {
                  registrationType = 1 // 普通人员升级研修班
                } else if (this.clevel === 8 && params.clevel === 7) {
                  registrationType = 2 // 普通人员升级体验班
                } else if (this.clevel === 7 && params.clevel === 6) {
                  registrationType = 3 // 体验班升级研修班
                }
              }
              // 只要身份有变动（升级或降级），无论有无凭证，都要构建customerRegistrationAddDTO
              if (params.clevel != 8) {
                // 降级时isUploadVoucher不显示，直接用false；升级时用用户选择值
                const hasVoucher = !isDowngrade && this.form.isUploadVoucher
                // 重新构建，确保包含所有必要字段（始终展开form中已有数据）
                let regDTO = this.form.customerRegistrationAddDTO || {}
                params.customerRegistrationAddDTO = {
                  ...regDTO,
                  customerId: this.form.customerAddDTO.id,
                  auditTime: null,
                  processingType: 2,
                  dataSource: 2,
                  registrationType: registrationType,
                  content: this.registrationRemark || null,
                  registrationPayList: hasVoucher ? (this.payVoucher.length ? this.payVoucher.map(i => ({ payImg: i.url, state: 0,dataType:0, registrationId: 0 })) : []) : []
                }
                // 清理多余字段
                delete params.customerRegistrationAddDTO.payList
                delete params.customerRegistrationAddDTO.createdBy
                delete params.customerRegistrationAddDTO.createdTime
                delete params.customerRegistrationAddDTO.createdUserLevelName
                delete params.customerRegistrationAddDTO.createdUserPO
                delete params.customerRegistrationAddDTO.id
                delete params.customerRegistrationAddDTO.operatedBy
                delete params.customerRegistrationAddDTO.operatedTime
                delete params.customerRegistrationAddDTO.auditUserId 
                delete params.customerRegistrationAddDTO.upgradeGiftAmount
              } else {
                // 降级为普通人员（clevel=8）时，仍需传递 customerRegistrationAddDTO 并携带 registrationType，其余字段传null
                params.customerRegistrationAddDTO = {
                  customerId: this.form.customerAddDTO.id,
                  auditTime: null,
                  processingType: 2,
                  dataSource: 2,
                  registrationType: registrationType,
                  registrationPayList: [],
                  content: this.registrationRemark || null,
                  applyVoucher: [...this.applyVoucher, ...this.attachmentFiles].map(i => i.url).join(',') || null,
                  lineUpBankType: null,
                  fee: 0,
                  num: null
                }
              }
            }
            if (this.popType == 2) params.lastDonote = this.form.lastDonote
            if (this.popType == 2 && this.form.customerAddDTO.clevel && this.form.customerAddDTO.clevel!=8 && (!this.clevel || (this.clevel>this.form.customerAddDTO.clevel))) params.giftCombineId = this.form.giftCombineId
          

            // 方案1：删除参数（推荐）
            if (!params.version && params.customerRegistrationAddDTO && params.customerRegistrationAddDTO.registrationPayList && params.customerRegistrationAddDTO.registrationPayList.length <= 0) {
              delete params.customerRegistrationAddDTO
            }


            try { if (this.canUseIntent && this.$refs.intentCredit) Object.assign(params, this.$refs.intentCredit.getSubmission(intentContext())) } catch (error) { this.isLoading = false; this.$message.warning(error.message); return }
            clientListApi.updateLevel(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            })
          }
          if ([3, 4, 5, 13, 14].includes(this.popType)) {
            let arr = []
            if ([3, 4, 5].includes(this.popType)) {
              arr = [{
                id: this.form.customerAddDTO.id,
                parentId: this.form.customerAddDTO.parentId,
                customerType: this.form.customerAddDTO.customerType,
                technicianId: this.form.customerAddDTO.technicianId,
                isOpenSea: this.form.customerAddDTO.isOpenSea,
                addrProvinceCode: this.popType == 5 ? this.form.customerAddDTO.addr[0] : null,
                addrCityCode: this.popType == 5 ? this.form.customerAddDTO.addr[1] : null,
                addrAreaCode: this.popType == 5 ? this.form.customerAddDTO.addr[2] : null,
                dataCompareLogType2: this.popType == 3 ? 6 : this.popType == 4 ? 7 : 8
                // addrDetail:this.popType==5?this.form.customerAddDTO.addrDetail:null
              }]
            } else {
              arr = this.selectItems.map(item => ({
                id: item.customer.id,
                isOpenSea: this.form.customerAddDTO.isOpenSea,
                parentId: this.popType == 13 ? this.form.customerAddDTO.parentId : item.customer.parentId,
                customerType: item.customer.customerType,
                technicianId: this.popType == 13 ? item.customer.technicianId : this.form.customerAddDTO
                  .technicianId,
                addrProvinceCode: null,
                addrCityCode: null,
                addrAreaCode: null,
                dataCompareLogType2: this.popType == 13 ? 6 : 7
                // addrDetail:null
              }))
            }
            // let params = {
            //   id: this.form.customerAddDTO.id,
            //   parentId: this.form.customerAddDTO.parentId,
            //   customerType: this.form.customerAddDTO.customerType,
            //   technicianId: this.form.customerAddDTO.technicianId
            // }
            // console.log('arr: ',arr);
            // return
            let Ins = this.popType === 5 ? clientListApi.updateSuperiors1 : clientListApi.updateSuperiors
            Ins(arr).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
          // sysDataconstantApi.update(params).then((data) => {
          //   this.postCallback(data)
          // });
        } else {
          console.log('error submit!!');
          this.isLoading = false
          return false;
        }
      });
    },
    async postCallback(data) {
      const msg = [3, 13, 4, 14, 5].includes(this.popType) ? '提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度' : (this.popType === 7 ? '提交成功，请等待审核' : '操作成功')
      this.$message.success(msg)
      this.isLoading = false
      if (this.popType === 5) {
        let { customer, cityCompany } = this.rowItem
        let { data } = await clientListApi.checkCityCompany({ customerid: customer ? customer.id : '', cityCompanyId: cityCompany ? cityCompany.id : '' })
        if (data.isChaoChu) {
          this.$confirm(`客户所属区域改变，是否同步修改城市公司`, '提示', {
            confirmButtonText: '同步修改',
            cancelButtonText: '暂不修改',
            type: 'warning'
          }).then(() => {
            this.formVisible = false;
            this.isLoading = false
            this.$emit('created', this.rowItem)
          }).catch(() => {
            this.formVisible = false;
            this.$emit('created')
          });
        }
      } else {
        this.formVisible = false;
        this.$emit('created')
      }
    },
    standingChange(e) {
      // this.form.customerAddDTO.profitRatioId = this.standingList.find(i => i.level == e).defaultProfitRatioId
      // if(!this.form.customerRegistrationAddDTO.fee){
      // 体验班
      if (this.form.customerAddDTO.clevel == 7) {
        this.form.customerRegistrationAddDTO.fee = this.configList.find(i => i.code == 'custFranchiseFeeL7').content * 1
      }
      // 研修班
      if (this.form.customerAddDTO.clevel == 6) {
        this.form.customerRegistrationAddDTO.fee = this.configList.find(i => i.code == 'custFranchiseFeeL6').content * 1
      }
      // 设置默认礼包
      this.setDefaultGiftGoods()

      if (this.popType == 2) {
        this.payVoucher = []
        this.applyVoucher = []
        this.attachmentFiles = []
        this.registrationRemark = ''
        this.$set(this.form.customerRegistrationAddDTO, 'registrationPayList', [])
      }
      // }
      console.log('e: ', e);
    },
    // 根据身份设置默认礼包
    setDefaultGiftGoods() {
      if (!this.form.customerAddDTO.clevel) return

      let configCode = ''
      if (this.form.customerAddDTO.clevel === 6) {
        // 研修班
        // this.clevel
        configCode = this.clevel === 7 && this.popType === 2 ? 'tyupxybansendgood' : 'upyanxiubansendgood'
      } else if (this.form.customerAddDTO.clevel === 7) {
        // 体验版
        configCode = 'uptiyanbansendgood'
      } else if (this.form.customerAddDTO.clevel === 8) {
        // 普通人员
        this.selectedGift = []
        this.$set(this.form, 'giftCombineId', '')
        return
      }

      if (configCode) {
        const config = this.configList.find(item => item.code === configCode)
        if (config && config.content) {
          try {
            // 假设配置中存储的是 {id, specId} 结构
            const defaultConfig = JSON.parse(config.content)
            if (defaultConfig && defaultConfig.id && defaultConfig.specId) {
              // 检查该商品和规格是否在级联数据中
              const goods = this.goodsList.find(item => item.id == defaultConfig.id)
              const spec = goods && goods.specValueList ? goods.specValueList.find(s => s.id == defaultConfig.specId) : null
              console.log('goods: ', goods);
              console.log('spec: ', spec);
              console.log('defaultConfig: ', defaultConfig);
              if (goods && spec) {
                // 设置级联选择的值
                this.selectedGift = [defaultConfig.id, defaultConfig.specId]
                // 同时设置 giftCombineId
                this.$set(this.form, 'giftCombineId', defaultConfig.specId)
              }
            }
          } catch (e) {
            console.error('解析默认礼包配置失败:', e)
          }
        }
      }
    },
    // 选择区域
    async regionChange(e) {
      // console.log('e: ', e);
      if (!e) return
      this.form.customerAddDTO.parentId = null
      this.form.customerAddDTO.technicianId = null
      this.technicalLine = ''
      this.customerLine = ''
      this.technicianList = []
      this.businessList = []

      await this.getTechnicianList(e)
      // await this.getBusinessList(e)
      // console.log('this.technicianList3333', this.technicianList)
      if (this.popType == 5) {
        if (this.technicianList.length && this.technicianList.findIndex(i => i.id == this.form.customerAddDTO.technicianId) == -1) {
          // this.form.customerAddDTO.technicianId = this.technicianList[this.technicianList.length - 1].id
        }
        if (this.businessList.length && this.businessList.findIndex(i => i.id == this.form.customerAddDTO
          .parentId) == -1) {
          this.form.customerAddDTO.parentId = this.businessList[this.businessList.length - 1].id
        }
      } else {
        this.getCityCompany(e)
        if (this.technicianList.length) {
          // this.form.customerAddDTO.technicianId = this.technicianList[this.technicianList.length - 1].id
        }
        if (this.businessList.length) {
          this.form.customerAddDTO.parentId = this.businessList[this.businessList.length - 1].id
        }
      }

    },
    getCityCompany(e) {
      SearchCityCompanyApi.SearchCityCompany({ provinceCode: e[0], cityCode: e[1], districtCode: e[2] }).then(({ data }) => {
        if (data) {
          this.form.customerAddDTO.cityCompanyId = data.id
        }
      })
    },
    // 技术老师选择
    technicianChange(e) {
      let obj = this.technicianList.find(i => i.id == e)
      // console.log('obj: ', obj);
      let str = `${obj.realName}【${obj.levelName}】`
      let arr = []
      if (obj.parentList && obj.parentList.length) {
        arr = obj.parentList.map(i => (`${i.realName}【${i.levelName}】`))
      }
      this.technicalLine = `${str}${arr.length ? ' - ' : ''}${arr.join(' - ')}`
    },
    // 业务员选择
    businessChange(e) {
      let obj = this.businessList.find(i => i.id == e)
      console.log('obj111: ', obj);
      let str = `${obj.name}【${obj.levelName}】 `
      let arr = []
      if (obj.parentList && obj.parentList.length) {
        arr = obj.parentList.map(i => (`${i.name}【${i.levelName}】`))
      }
      this.customerLine = `${str}${arr.length ? ' - ' : ''}${arr.join(' - ')}`
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload--picture-card {
  width: 54px;
  height: 54px;
  line-height: 62px;
}

::v-deep .el-upload-list__item {
  width: 54px;
  height: 54px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-dialog {
  max-height: 88vh;
  margin-top: 6vh !important;
}

::v-deep .el-form {
  max-height: 64vh !important;
  overflow-y: auto;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item.width100 {
  width: 97%;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 54px;
  height: 54px;
  line-height: 54px;
  text-align: center;
}

.avatar {
  width: 54px;
  height: 54px;
  display: block;
}

.card-uploader img {
  height: 132px;
  width: 194px;
  margin-right: 56px;
}

.upload-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}
</style>
